// Listen for events on the checkbox with ID "RegisterForm-marketing"
document.addEventListener('DOMContentLoaded', () => {
  const marketingCheckbox = document.getElementById('RegisterForm-marketing');
  if (marketingCheckbox) {
    marketingCheckbox.addEventListener('change', showDetails);
    // Initial call to set the correct display state on page load
    showDetails();
  }
});

const showDetails = () => {
  // Shows the element with the ID 'RegisterForms-details' when the input with ID "RegisterForm-marketing" is checked
    const detailsElement = document.getElementById('RegisterForm-details');
    const marketingCheckbox = document.getElementById('RegisterForm-marketing');
    if (marketingCheckbox && detailsElement) {
      if (marketingCheckbox.checked) {
        detailsElement.classList.remove('hidden');
      } else {
        detailsElement.classList.add('hidden');
      }
    }
}